import type { IPaginationStorageService } from "@/application/ports/services/IPaginationStorageService";
import type { IStorageService } from "@/application/ports/services";
import { STORAGE_KEYS } from "./constants";

export class PaginationStorageService implements IPaginationStorageService {
  constructor(private storageService: IStorageService) {}

  getItemsPerPage(): number | null {
    const stored = this.storageService.get<string>(STORAGE_KEYS.PAGINATION_ITEMS_PER_PAGE);
    if (stored) {
      const parsed = parseInt(stored, 10);
      if (!isNaN(parsed) && parsed > 0) {
        return parsed;
      }
    }
    return null;
  }

  setItemsPerPage(value: number): void {
    this.storageService.set(STORAGE_KEYS.PAGINATION_ITEMS_PER_PAGE, String(value));
  }
}
